export default __webpack_public_path__ + "static/media/waiting.7230f911.gif";